import { Box, Button, Typography } from "@mui/joy";
import Add from '@mui/icons-material/Add';
import React, { useEffect, useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { removeClient } from "../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { removeIndustry } from "../../service/industryService";
import { RouteComponentProps } from "../../models/RouteComponent";
import { appointmentsRemove, appointmentsUpdate, getAppointmentsTree } from "../../service/appointmentsService";
import { useNavigate } from "react-router-dom";

import { OrganizationChart } from 'primereact/organizationchart';
import { TabPanel, TabView } from "primereact/tabview";
import { Card } from "primereact/card";

import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';


export default function AppointmentsTree(props: RouteComponentProps) {

  const navigate = useNavigate();

  const [data, setData] = useState([] as any[]);
  const [loading, setLoading] = useState(false);

  const loadLazyData = () => {
    if (!loading) {
      setLoading(true);
      getAppointmentsTree().then(data => {
        console.log("getAppointmentsTree data = ", data);
        setData(data);
      }).catch((error) => {
        console.log("error == ", error);
        setData([]);
      });
    }
  }

  useEffect(() => {
    loadLazyData();
  }, [])



  return (
    <React.Fragment>
      <TabView>
        <TabPanel header="Orientation Tree">
          <Card>
            <TreeTable value={data} scrollable scrollHeight="100vh" tableStyle={{ minWidth: '50rem' }}>
              <Column field="name" header="Name" expander></Column>
              <Column field="child_count" header="Child Count"></Column>
            </TreeTable>
          </Card>
        </TabPanel>
        <TabPanel header="Orientation Chart">
          <Card>
            <OrganizationChart value={data} />
          </Card>
        </TabPanel>
      </TabView>

    </React.Fragment>
  );
}